import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from 'react-query'

import WorkOrderDetail from './WorkOrderDetail'
import { ContainerProvider } from '../../containerContext'
import { useApi, useLoading } from '../../../hooks'
import useAppContext from '../../app'
import { Container } from 'react-bootstrap'
import Riband from '../../Riband'
import AppointmentPanel from '../appointment/AppointmentPanel';
import { eventIdOf, isSchedulingEnabled } from '../../../utils/appointment';

const Index = () => {
  const queryClient = useQueryClient()
  const [state, setState] = useState({})
  const params = useParams()
  const { workorderService } = useApi()
  const { store: { isLog, featureFlags } } = useAppContext()
  const { workOrderId = '' } = params

  const { isLoading, data, isSuccess } = useQuery(['workorder-detail'], () => {
    return workorderService.get(workOrderId).then(({ workOrder }) => workOrder)
  }, {
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    return () => {
      queryClient.removeQueries(['workorder-detail'])
    }
  }, [queryClient])

  useLoading(isLoading)

  const closeModalPhoto = () => {
    setState(prev => {
      return { ...prev, vehicle: null, showModalPhoto: false, initialSlide: 0 }
    })
  }

  const showPhotoModal = (vehicle = {}, initialSlide = 0) => {
    setState(prev => {
      return { ...prev, vehicle, showModalPhoto: true, initialSlide }
    })
  }

  return (
    <ContainerProvider
      state={state}
      setState={setState}
      data={data}
      closeModalPhoto={closeModalPhoto}
      showPhotoModal={showPhotoModal}
    >
    	{/* US-37724. Nothing renders until the shop books this document in. */}
    	<AppointmentPanel
    		eventId={eventIdOf(data?.workOrder)}
    		enabled={isSchedulingEnabled(featureFlags)}
    	/>
      <div className='w-100 d-flex flex-column'>
        {!isLog && data?.client?._id?.canAccessPortal && (
          <Riband />
        )}
        <Container>
          {isSuccess && <WorkOrderDetail />}
        </Container>
      </div>
    </ContainerProvider>
  )
}

export default Index
